// extracted by mini-css-extract-plugin
export var brand = "_bb-9";
export var compact = "_bb-6";
export var extraSmall = "_bb-7";
export var icon = "_bb-0";
export var large = "_bb-4";
export var light = "_bb-1";
export var medium = "_bb-5";
export var outline = "_bb-b";
export var primaryDark = "_bb-a";
export var primaryLight = "_bb-8";
export var primaryModern = "_bb-c";
export var success = "_bb-2";
export var successSolid = "_bb-3";